export default __webpack_public_path__ + "static/media/c_web_logo_2x_color.eb43b279.png";